<template>
<el-form ref="form" :model="hist" label-width="120px">
    <el-row :xs="24" sm="12">
        <el-col :xs="24" :sm="18">
            <el-form-item :label="msg('操作类型')">
                <el-input v-model="hist.type" readonly="readonly"></el-input>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="18">
            <el-form-item :label="msg('操作时间')">
                <el-input v-model="hist.created" readonly="readonly"></el-input>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="18">
            <el-form-item :label="msg('用户名')">
                <el-input v-model="hist.fullname" readonly="readonly"></el-input>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="18">
            <el-form-item :label="msg('IP地址')">
                <el-input v-model="hist.ip" readonly="readonly"></el-input>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="18">
            <el-form-item :label="msg('请求URL')">
                <el-input v-model="hist.url" readonly="readonly"></el-input>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24">
            <el-form-item :label="msg('操作内容')">
                <el-input type="textarea" :rows="3" v-model="hist.param" readonly="readonly"></el-input>
            </el-form-item>
        </el-col>
    </el-row>
    
    <div style="text-align:center;">
        <el-button  size="mini" v-on:click="$emit('close-dg')">{{msg('确定')}}</el-button>
    </div>

</el-form> 
</template>

<script>
export default {
  name: 'ProductEdit',
  data(){
    return{
    }
  }, 
  computed:{
  },
  props:{
        hist: Object,
  },
  mounted: function(){
       
  },
  methods:{
    onSubmit(){
    },
  }
}
</script>


<style scoped lang="scss">
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 64px;
        height: 64px;
        line-height: 64px;
        text-align: center;
    }
    .avatar {
        width: 64px;
        height: 64px;
        display: block;
    }

.w-e-toolbar{flex-wrap: wrap;}
.icon-list{ margin:0px; padding:0px; display:flex; flex-wrap:wrap;  border: 1px solid #eaeefb;}
.icon-list li{cursor:pointer;
    padding:8px; border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    display:flex; flex-direction: column; justify-content: center; align-items:center;
}
.icon-list li i{font-size:18px;} 
.icon-list li:hover{color:#5CB6FF;}
.upload-icon .el-form-item__content{display:flex;}
.upload-icon .el-form-item__content >*:last-child{margin-left:10px;}
</style>
